import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.UserList.DelegateCell', {
    selectDelegateText: 'Select substitute',
    deleteText: 'Remove user',
    delegateRemovedFromCompany: 'The substitute has been removed from the company',
    title: 'About Substitution',
    description: `
        Substitution allows to cover cases when approver{br} becomes temporary unavailable
        and someone{br} else needs to make decisions for them.`,
    selectDelegatePanelButtonText: 'Select a Substitute',
});
